// src/components/album/StepOrganizer.jsx
import React from 'react';
import {
    VStack,
    Heading,
    Text,
    Flex,
    HStack,
    Box,
    Badge,
    Image,
    IconButton,
    Button,
    Divider,
    Checkbox,
    Tooltip,
    Spinner,
    useBreakpointValue,
} from '@chakra-ui/react';
import {
    FiArrowLeft,
    FiArrowRight,
    FiTrash2,
    FiInfo,
} from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';

const StepOrganizer = ({
    selectedImages,
    onRemoveImage,
    onMoveImage,
    specialPages,
    onSpecialPagesChange
}) => {
    const navigate = useNavigate();
    const buttonSize = useBreakpointValue({ base: "sm", md: "md" });

    return (
        <VStack spacing={6} align="stretch" w="100%">
            <Heading size="md" color="gray.700">Organizar Páginas</Heading>
            <Text color="gray.500">Reordene as imagens arrastando os botões de seta</Text>

            {selectedImages.length > 0 ? (
                <VStack spacing={3} align="stretch">
                    {selectedImages.map((image, index) => (
                        <Flex
                            key={image.id}
                            p={3}
                            borderWidth="1px"
                            borderRadius="md"
                            align="center"
                            bg="white"
                            wrap="wrap"
                            gap={2}
                        >
                            <HStack>
                                <IconButton
                                    icon={<FiArrowLeft />}
                                    variant="ghost"
                                    size="sm"
                                    isDisabled={index === 0}
                                    onClick={() => onMoveImage(index, 'up')}
                                    aria-label="Mover para cima"
                                />
                                <IconButton
                                    icon={<FiArrowRight />}
                                    variant="ghost"
                                    size="sm"
                                    isDisabled={index === selectedImages.length - 1}
                                    onClick={() => onMoveImage(index, 'down')}
                                    aria-label="Mover para baixo"
                                />
                            </HStack>
                            <Badge mr={3} ml={2}>{index + 1}</Badge>
                            <Image
                                src={image.generated_image_url}
                                alt={image.title}
                                boxSize={{ base: "40px", md: "50px" }}
                                objectFit="cover"
                                borderRadius="md"
                                mr={3}
                                fallback={<Spinner size="sm" />}
                            />
                            <Text flex="1" noOfLines={1}>{image.title || `Imagem ${index + 1}`}</Text>
                            <IconButton
                                icon={<FiTrash2 />}
                                colorScheme="red"
                                variant="ghost"
                                size="sm"
                                onClick={() => onRemoveImage(image.id)}
                                aria-label="Remover imagem"
                            />
                        </Flex>
                    ))}
                </VStack>
            ) : (
                <Box p={6} bg="gray.50" borderRadius="lg" textAlign="center">
                    <Text>Nenhuma imagem adicionada ao livro</Text>
                    <Button
                        mt={4}
                        colorScheme="blue"
                        onClick={() => navigate('/dashboard')}
                        size={buttonSize}
                    >
                        Adicionar imagens
                    </Button>
                </Box>
            )}

            <Divider my={4} />

            <Box>
                <HStack mb={4} align="center">
                    <Heading size="sm">Páginas especiais (opcional)</Heading>
                    <Tooltip label="Adicione páginas com instruções, certificado ou informações sobre o artista">
                        <Box cursor="help">
                            <FiInfo />
                        </Box>
                    </Tooltip>
                </HStack>
                <VStack align="start" spacing={3}>
                    <Checkbox
                        isChecked={specialPages.includes('instructions')}
                        onChange={(e) => {
                            if (e.target.checked) {
                                onSpecialPagesChange([...specialPages, 'instructions']);
                            } else {
                                onSpecialPagesChange(specialPages.filter(page => page !== 'instructions'));
                            }
                        }}
                    >
                        <VStack align="start" spacing={0}>
                            <Text>Adicionar página de instruções</Text>
                            <Text fontSize="xs" color="gray.500">
                                Dicas de como colorir e materiais recomendados
                            </Text>
                        </VStack>
                    </Checkbox>

                    <Checkbox
                        isChecked={specialPages.includes('certificate')}
                        onChange={(e) => {
                            if (e.target.checked) {
                                onSpecialPagesChange([...specialPages, 'certificate']);
                            } else {
                                onSpecialPagesChange(specialPages.filter(page => page !== 'certificate'));
                            }
                        }}
                    >
                        <VStack align="start" spacing={0}>
                            <Text>Adicionar certificado de conclusão</Text>
                            <Text fontSize="xs" color="gray.500">
                                Para a pessoa preencher quando terminar o livro
                            </Text>
                        </VStack>
                    </Checkbox>

                    {/* 
                    <Checkbox
                        isChecked={specialPages.includes('about')}
                        onChange={(e) => {
                            if (e.target.checked) {
                                onSpecialPagesChange([...specialPages, 'about']);
                            } else {
                                onSpecialPagesChange(specialPages.filter(page => page !== 'about'));
                            }
                        }}
                    >
                        
                        <VStack align="start" spacing={0}>
                            <Text>Adicionar página "Sobre o artista"</Text>
                            <Text fontSize="xs" color="gray.500">
                                Espaço para a criança escrever sobre si
                            </Text>
                        </VStack>
                    </Checkbox>
                    */}
                </VStack>
            </Box>
        </VStack>
    );
};

export default StepOrganizer;